export default __webpack_public_path__ + "static/media/pidoCarOnline.56a75ad8.png";